
 import React from 'react';
 import { connect } from 'react-redux';
 const LoaderSpinner = (props) => {

    return <>
    {props.loader && <><div className="spinner-bg" role="load">
    {props.loaderWithMsg && <><div className='spinnermsg'>{props.labels['corporatesignup.loading.message']}</div></>}
     <ul className="spinner">
          <li className="bounce1"></li>
          <li className="bounce2"></li>
          <li className="bounce3"></li>
        </ul>
      </div> </>
 }
</>

 }
 const mapStateFromReducer = (state) => ({
  labels: state.corporateSignupReducer.labels || {}
})
 export default connect(
  mapStateFromReducer,
  null
)(LoaderSpinner);